import styled, { css } from "styled-components/macro";
import type { Layout } from "styles/elements/ElementsInterface";

export const Heading1Css = css`
  font-family: ${(props: Layout) => props.theme.font.family.text.bold};
  font-size: ${(props: Layout) => props.theme.font.size._48};
  margin-bottom: ${(props: Layout) => props.theme.font.size._32};
  line-height: ${(props: Layout) => props.theme.font.size._48};
  margin-top: 0;
  word-break: break-word;
  color: ${(props: Layout) => props.theme.palette.neutral.black};
  letter-spacing: -0.1rem;
`;

export const Heading1 = styled.h1<Layout>`
  ${Heading1Css}
  ${(props: Layout) => (props.customStyle ? props.customStyle : "")}
`;

export const Heading2Css = css`
  font-family: ${(props: Layout) => props.theme.font.family.text.bold};
  font-size: ${(props: Layout) => props.theme.font.size._32};
  margin-bottom: ${(props: Layout) => props.theme.font.size._24};
  line-height: ${(props: Layout) => props.theme.font.size._32};
  margin-top: 0;
  word-break: break-word;
  color: ${(props: Layout) => props.theme.palette.neutral.black};
  letter-spacing: -0.1rem;
`;

export const Heading2 = styled.h2<Layout>`
  ${Heading2Css}
  ${(props: Layout) => (props.customStyle ? props.customStyle : "")}
`;

export const Heading3Css = css`
  font-family: ${(props: Layout) => props.theme.font.family.text.bold};
  font-size: ${(props: Layout) => props.theme.font.size._24};
  margin-bottom: ${(props: Layout) => props.theme.font.size._18};
  line-height: ${(props: Layout) => props.theme.font.size._24};
  letter-spacing: -0.05rem;
  margin-top: 0;
  word-break: break-word;
  color: ${(props: Layout) => props.theme.palette.neutral.black};
`;

export const Heading3 = styled.h3<Layout>`
  ${Heading3Css}
  ${(props: Layout) => (props.customStyle ? props.customStyle : "")}
`;

export const Heading4Css = css`
  font-family: ${(props: Layout) => props.theme.font.family.text.bold};
  font-size: ${(props: Layout) => props.theme.font.size._18};
  margin-bottom: ${(props: Layout) => props.theme.font.size._16};
  line-height: ${(props: Layout) => props.theme.font.size._18};
  margin-top: 0;
  word-break: break-word;
  color: ${(props: Layout) => props.theme.palette.neutral.black};
`;

export const Heading4 = styled.h4<Layout>`
  ${Heading4Css}
  ${(props: Layout) => (props.customStyle ? props.customStyle : "")}
`;

export const Heading5Css = css`
  font-family: ${(props: Layout) => props.theme.font.family.text.bold};
  font-size: ${(props: Layout) => props.theme.font.size._14};
  margin-bottom: ${(props: Layout) => props.theme.font.size._12};
  line-height: ${(props: Layout) => props.theme.font.size._14};
  margin-top: 0;
  word-break: break-word;
  color: ${(props: Layout) => props.theme.palette.neutral.black};
`;

export const Heading5 = styled.h5<Layout>`
  ${Heading5Css}
  ${(props: Layout) => (props.customStyle ? props.customStyle : "")}
`;

export const Heading6Css = css`
  font-family: ${(props: Layout) => props.theme.font.family.text.bold};
  font-size: ${(props: Layout) => props.theme.font.size._12};
  margin-bottom: ${(props: Layout) => props.theme.font.size._14};
  margin-top: 0;
  word-break: break-word;
  color: ${(props: Layout) => props.theme.palette.neutral.black};
`;

export const Heading6 = styled.h6<Layout>`
  ${Heading6Css}
  ${(props: Layout) => (props.customStyle ? props.customStyle : "")}
`;
